import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { hasRole, INTERNAL_ROLES } from "@/lib/roles";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import CoiDialog from "@/components/CoiDialog";

/** Banner listing assessments where the user must still confirm the COI declaration. */
export default function CoiPendingBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [current, setCurrent] = useState(null);
  const internal = hasRole(user, ...INTERNAL_ROLES);

  const load = useCallback(async () => {
    if (!internal) return;
    try {
      const { data } = await api.get("/me/coi-pending");
      setItems(data);
    } catch { /* non-blocking */ }
  }, [internal]);
  useEffect(() => {
    load();
    window.addEventListener("coi:changed", load);
    return () => window.removeEventListener("coi:changed", load);
  }, [load]);

  if (!items.length) return null;
  return (
    <div className="mx-4 sm:mx-6 lg:mx-8 mt-4 rounded-xl border border-amber-300 bg-amber-50 p-4" data-testid="coi-pending-banner">
      <div className="flex items-center gap-2 text-amber-800 font-semibold text-sm mb-2">
        <AlertTriangle className="w-4 h-4" />
        Dichiarazioni di assenza di conflitti di interesse da confermare ({items.length})
      </div>
      <p className="text-xs text-amber-700 mb-3">Finché non confermi, non puoi operare su questi assessment.</p>
      <ul className="space-y-2">
        {items.map((it) => (
          <li key={`${it.assessment_id}-${it.slot}`} className="flex flex-wrap items-center justify-between gap-2 text-sm bg-white rounded-lg px-3 py-2 border border-amber-200">
            <span>
              <b>{it.organization_name || "Azienda"}</b> · {it.year} — <span className="text-slate-600">{it.slot_label}</span>
            </span>
            <Button size="sm" onClick={() => setCurrent(it)} data-testid={`coi-open-${it.assessment_id}-${it.slot}`}
                    className="h-8 bg-amber-600 hover:bg-amber-700 text-white">
              Conferma dichiarazione
            </Button>
          </li>
        ))}
      </ul>
      <CoiDialog item={current} onClose={() => setCurrent(null)}
                 onDone={() => window.dispatchEvent(new Event("coi:changed"))} />
    </div>
  );
}
